import { UpdateEcshopTradesApi } from "@/features/accounts/ecshop/services/update-trades-api";
import { PostEcshopTradesRequestModel } from "@/features/accounts/ecshop/services/update-trades-model";

/// その他連携明細更新処理
export class UpdateEcshopTradesService {
  private updateEcshopTradesApi = new UpdateEcshopTradesApi();

  /**
   * その他連携明細更新API実行
   */
  public async updateEcshopTrades(param: PostEcshopTradesRequestModel) {
    return await this.updateEcshopTradesApi.updateEcshopTrades(param);
  }
}
